import script from "./picture-upload-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./picture-upload-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__